var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 0.329782,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 0.329782,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    stroke: "#E2E2EA",
    strokeWidth: 0.659565
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9761 13.7335C15.6457 13.7335 16.9991 12.3801 16.9991 10.7105C16.9991 9.04095 15.6457 7.6875 13.9761 7.6875C12.3066 7.6875 10.9531 9.04095 10.9531 10.7105C10.9531 12.3801 12.3066 13.7335 13.9761 13.7335Z",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1683 19.7791C19.1683 17.4393 16.8406 15.5469 13.9748 15.5469C11.109 15.5469 8.78125 17.4393 8.78125 19.7791",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutline);
export default __webpack_public_path__ + "static/media/profile-outline.ba8d89c152acafae3ca15f9c193e78c8.svg";
export { ForwardRef as ReactComponent };